// import axios from 'axios'
import { post, put, get, remove } from '@/api/api'

export const actions = {
  fetchPayss ({ commit}) {
    // const { pageNumber = 0, pageSize = state.pagination.size } = params
    return get(`/canal/pays`)
      .then(({ data }) => {
        commit('addPayss', data)
      })
  },
  async fetchPaysPage({commit}, params = {}) {
    const { pageNumber = 0, pageSize = 10, sort = '', nom = '', code = '', after = '', before = '' } = params;
    const queryParams = new URLSearchParams({
      pageNumber,
      pageSize,
      sort, 
      ...(code && { code }),
      ...(nom && { nom }),
      ...(after && { after }),
      ...(before && { before }),
    }).toString();

    let { data } = await get(`/canal/pays/page?${queryParams}`);
    commit("addPaysPage", data)
    return data;
  },
  createPays ({ commit }, pays) {
    return post('/canal/pays', pays)
      .then(({ data }) => {
        commit('addPays', data)
      })
  },
  updatePays ({ commit }, pays) {
    return put(`/canal/pays/${pays.id}`, pays)
      .then(({ data }) => {
        commit('replacePays', data)
      })
  },
  createOrUpdatePays ({ dispatch }, pays) {
    if (pays.id !== undefined) {
      return dispatch('updatePays', pays)
    } else {
      return dispatch('createPays', pays)
    }
  },
  deletePays ({ commit}, pays) {
    // const { pageNumber = 0, pageSize = state.pagination.size } = params
    return remove(`/canal/pays/${pays.id}`)
      .then(({ data }) => {
        
      })
  },
  selectPays ({ commit }, pays) {
    commit('setPays', pays)
  }
}
